/**
 * [Syntax]
 * name: will be used to retrieve the loaded resources.
 * type: what loader to use.
 * path: the path(s) of the file(s) to load.
 */

export default [
    {
        name: 'gradientTexture',
        type: 'allTexture',
        path:
        [
            '/gradients/5.jpg',
        ]
    },
    {
        name: 'fontTexture',
        type: 'fontTexture',
        path:
        [
            'font/Bangers_Regular.json',
        ]
    },
    {
        name: 'cleanTexture',
        type: 'fontTexture',
        path:
        [
            'font/Source Code Pro_Bold.json',
        ]
    },
    {
        name: 'robotTexture',
        type: 'fontTexture',
        path:
        [
            'font/VT323_Regular.json',
        ]
    },
    {
        name: 'particlesTexture',
        type: 'starTexture',
        path:
        [
            '/particles/4.png',
        ]
    },
    {
        name: 'sunTexture',
        type: 'allTexture',
        path:
        [
            '/planets/sun.jpg',
        ]
    },
    {
        name: 'neptune',
        type: 'allTexture',
        path:
        [
            '/planets/neptune.jpg',
        ]
    },
    {
        name: 'mars',
        type: 'allTexture',
        path:
        [
            '/planets/mars.jpg',
        ]
    },
    {
        name: 'mercury',
        type: 'allTexture',
        path:
        [
            '/planets/mercury.jpg',
        ]
    },
    {
        name: 'venus',
        type: 'allTexture',
        path:
        [
            '/planets/venus.jpg',
        ]
    },
    {
        name: 'earth',
        type: 'allTexture',
        path:
        [
            '/planets/earth.jpg',
        ]
    },
    {
        name: 'jupiter',
        type: 'allTexture',
        path:
        [
            '/planets/jupiter.jpg',
        ]
    },
    {
        name: 'saturn',
        type: 'allTexture',
        path:
        [
            '/planets/saturn.jpg',
        ]
    },
    {
        name: 'uranus',
        type: 'allTexture',
        path:
        [
            '/planets/uranus.jpg',
        ]
    },

]